module.exports = __webpack_public_path__ + "static/img/fm14.73f38e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm14.jpg
// module id = NvTs
// module chunks = 1